import { Vue, Component, Prop, PropSync, InjectReactive } from 'vue-property-decorator';
import Dictionary from '@/types/Dictionary';
import WorkContext from '@/components/commons/Work/WorkContext';
import WorkState from './Work/WorkState';

/** Structure commune à tous les composants Work */
@Component
export class Work extends Vue {
    /** Variant de couleur à appliquer sur le composant Work */
    @InjectReactive()
    protected Variant!: string;

    /** Résultats du composant Work à afficher */
    @PropSync('Results', {default: () => {}})
    public results!: any;

    /** Données synchronisées pour le composant appelant */
    @PropSync('Configs', { default: () => [{}] })
    public configs!: Dictionary<any>;

    /**
     * Indique si le composant est en cours de chargement ou non
     * ==> le b-skeleton-wrapper affiche alors l'egraph grisé avec le contenu d'optionInit en attendant le chargement complet des données
     * */
    @Prop({default: false})
    public Loading!: boolean;

    //#region Affichage en mode fullscreen

    /** Indique si un widget est affiché en "plein écran" ou non dans une modale */
    protected fullscreen: boolean = false;

    /**
     * Nom du portal vers lequel déporter l'affichage du bouton pour le fullscreen.
     * Si vide alors pas de départ. Le bouton est affiché dans ce composant
     */
    @Prop()
    public FSButtonPortalName!: string;

    //#endregion Affichage en mode fullscreen

    /**
     * Titre
     * @todo ici le titre à afficher si besoin
     */
    @Prop({default: ''})
    public Title!: string;
}

/** Structure commune à tous les composants Work gérant des implémentations selon différents contexts */
@Component
export class WorkExtended<WC extends WorkContext> extends Work {
    /** Context du composant parent : Widget, WidgetConfig ou Analysis */
    @InjectReactive()
    private parentContext!: string;

    /** Contexte du Work pour définir/utiliser des implémentations selon différents états (machine à états) */
    protected context: WC = null;

    /** 
     * Initialisation de la machine à état
     * @param workName          Nom du Work
     * @param contextFactory    Pointeur de fonction vers constructeur du contexte ciblé
     * @param subState          Sous-état facultatif
     **/
    protected async initStateMachine<WS extends WorkState>(workName: string, contextFactory: (state: WS, results: any, configs: Dictionary<any>, variant: string) => WC, subState = undefined) {
        console.debug("Work - initStateMachine - workName : %O - contextFactory : %O - subState : %O - this.parentContext : %O", workName, contextFactory, subState, this.parentContext);

        /** Type de l'état à instancier */
        let stateType;
        if (subState)
            stateType = await import("@/components/commons/Work/" + workName + "Work/" + workName + "State/" + this.parentContext + "/" + subState + workName + "State");
        else
            stateType = await import("@/components/commons/Work/" + workName + "Work/" + workName + "State/" + this.parentContext + workName + "State");

        /** Instanciation dynamique de l'état */
        const stateInstance = new stateType.default();

        /** Instancie un nouveau contexte ou bien réalise une transition vers un autre type d'état si l'instance de contexte existe déjà */
        console.debug("Work - initStateMachine - context (avant) : %O", this.context);

        if (this.context) {
            console.debug("Work - initStateMachine() - Vrai");
            this.context.TransitionTo(stateInstance);
        }
        else {
            console.debug("Work - initStateMachine() - faux");
            this.context = contextFactory(stateInstance, this.results, this.configs, this.Variant);
        }

        this.context.GoStandard();

        console.debug("Work - initStateMachine - context (après) : %O", this.context);
    }
}